/*
 * @Author: Dom
 * @Date: 2022-06-02 13:28:43
 * @LastEditTime: 2022-07-22 10:11:01
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\utils\download.ts
 */
import axios from 'axios'
import qs from 'qs'
import {message} from 'ant-design-vue'
import store from '@/config/store'


/**
 * 下载
 * @param res 返回文件流
 * @param type 文件类型
 * @param fileName 文件名
 */
function blobDownloadFile(res: any, type: string, fileName: string){
    const blob = new Blob([res],{type})
    const a = document.createElement('a')
    const URL = window.URL || window.webkitURL
    const href = URL.createObjectURL(blob)
    a.href = href
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(href)
}

interface DataType {
    url: string;
    meth: any;
    params: any;
    type: string;
    filename: string;
    dType?: string;
}

// axios定义loading状态
axios.interceptors.request.use((config)=>{
    store.dispatch('loading/changeLoading',true)
    return config
},(err) => {
    return Promise.reject(err)
})
axios.interceptors.response.use((response)=>{
    store.dispatch('loading/changeLoading',false)
    return response
},(err) => {
    return Promise.reject(err)
})

/**
 *
 * @param data
 * params: 参数
 * url: 请求地址
 * meth: 请求方法
 * filename: 下载后文件名及后缀，如:XXX.xsl
 * type: 下载类型
 * dType: 传给服务端的数据类型(from格式，json格式)
 */
export default function downloadfile(data: DataType){
    const params:any = data.meth.toLowerCase() === 'post' ? {
        url: process.env.VUE_APP_APIHOST + data.url,
        method: data.meth,
        data: data?.dType == 'form' ? qs.stringify(data.params) : data.params,
        responseType: 'blob'
    } : {
        url: process.env.VUE_APP_APIHOST + data.url,
        method: data.meth,
        params: data?.dType == 'form' ? qs.stringify(data.params) : data.params,
        responseType: 'blob'
    }
    axios(params).then(res => {
        blobDownloadFile(res.data,data.type,data.filename)
    }).catch((error)=>{
        message.warning(error)
    })
}
